import React from 'react';
import PropTypes from 'prop-types';
import './table.scss';

const Table = ({ children, header, className }) => {
  return (
    <div className={`table-default ${className}`}>
      {header &&
        <div className='table-default__row table-default--header'>
          {header.map((column, index) => <div className='table-default__cell table-default--headings' key={index}> {column}</div>)}
        </div>
      }
      {children}
    </div>
  );
};

Table.propTypes = {
  header: PropTypes.array,
  children: PropTypes.node
};

export default Table;
